import { useTranslation } from "react-i18next";
import { Check, X } from "lucide-react";
import { PasswordInput } from "./PasswordInput";
import { PasswordStrength } from "./PasswordStrength";
import { PasswordRules } from "./PasswordRules";
import { isStrongPassword } from "../../lib/passwordPolicy";

// حقلا كلمة المرور وتأكيدها مع عدّاد قوة ديناميكي، شروط حيّة، ومؤشر تطابق فوري.
export const PasswordPair = ({
  password,
  confirm,
  onPasswordChange,
  onConfirmChange,
  testId = "password",
  passwordPlaceholder,
  confirmPlaceholder,
  className = "",
}) => {
  const { t } = useTranslation();
  const strong = isStrongPassword(password);
  const match = Boolean(confirm) && password === confirm;

  return (
    <div className={`space-y-3 ${className}`}>
      <div>
        <PasswordInput
          data-testid={testId}
          required
          placeholder={passwordPlaceholder || t("auth.newPassword")}
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
        />
        <PasswordStrength value={password} className="mt-2" />
        <PasswordRules value={password} className="mt-2" />
      </div>
      <div>
        <PasswordInput
          data-testid={`${testId}-confirm`}
          required
          placeholder={confirmPlaceholder || t("auth.confirmPassword")}
          value={confirm}
          onChange={(e) => onConfirmChange(e.target.value)}
        >
          {confirm ? (
            <span
              className={`absolute end-11 top-1/2 -translate-y-1/2 ${match ? "text-emerald-600" : "text-destructive"}`}
              data-testid="password-match"
            >
              {match ? <Check className="h-5 w-5" /> : <X className="h-5 w-5" />}
            </span>
          ) : null}
        </PasswordInput>
        {confirm ? (
          <p
            className={`mt-1 text-[11px] font-bold ${match ? "text-emerald-600" : "text-destructive"}`}
            data-testid="password-match-hint"
          >
            {t(match ? "auth.passwordsMatch" : "auth.passwordsMismatch")}
          </p>
        ) : null}
      </div>
    </div>
  );
};

// جاهزية الحفظ: كل الشروط محققة + تطابق تام.
export const passwordPairReady = (password, confirm) =>
  isStrongPassword(password) && Boolean(confirm) && password === confirm;
